import { Component, OnInit, OnDestroy } from '@angular/core';
import {
  CartTotalStepComponent,
  Price,
  TotalObject,
  CartTotalsService,
  SelectedCustomerService,
  GungFlowService,
  GungFlow,
  AuthService,
  MetadataService
} from 'gung-standard';
import { Subscription } from 'rxjs';
import { first } from 'rxjs';

@Component({
  selector: 'cult-cult-cart-total-step',
  templateUrl: './cult-cart-total-step.component.html',
  styleUrls: ['./cult-cart-total-step.component.scss']
})
export class CultCartTotalStepComponent extends CartTotalStepComponent implements OnInit, OnDestroy {
  private freightFreeLimitValue: number = null;
  private totals: TotalObject = null;
  public currentFlow: GungFlow;
  isReturNoPrice = false;

  private cartTotalsSubscription: Subscription;

  get freightFree(): { display: boolean; diffToTotal: Price } {
    if (this.freightFreeLimitValue && this.totals) {
      const diff = this.freightFreeLimitValue - this.totals.totalValue;
      if (diff > 0) {
        // Order amount below freight free limit
        return {
          display: true,
          diffToTotal: { value: diff, currencyCode: this.totals.totalCurrency }
        };
      }
    }
    return { display: false, diffToTotal: null };
  }

  constructor(
    private cartTotalsService: CartTotalsService,
    private selectedCustomerService: SelectedCustomerService,
    protected gungFlowService: GungFlowService,
    protected authService: AuthService,
    public metadataService?: MetadataService
  ) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();

    this.cartTotalsSubscription = this.cartTotalsService.getTotals().subscribe(totalsObject => {
      this.totals = totalsObject;
    });

    this.selectedCustomerService.getSelectedCustomer().subscribe(customer => {
      this.freightFreeLimitValue = 100;
      if (customer.extra.kus.levvillkkod) {
        let freightFreeLimitValueMetadata = this.metadataService.getMetadataValue('x2e', 'q_ah_beloppsgrans', customer.extra.kus.levvillkkod);
        this.freightFreeLimitValue = Number(freightFreeLimitValueMetadata);
      } else if (customer && customer.extra._freightFreeLimit) {
        this.freightFreeLimitValue = customer.extra._freightFreeLimit;
      }
    });

    this.gungFlowService
      .getSelectedFlow()
      .pipe(first())
      .subscribe(currentFlow => {
        this.currentFlow = currentFlow;
      });

    this.authService
      .getCurrentUser()
      .pipe(first())
      .subscribe(user => {
        this.isReturNoPrice = user.roles.includes('RETUR_NOPRICE');
      });
  }

  ngOnDestroy(): void {
    if (this.cartTotalsSubscription) {
      this.cartTotalsSubscription.unsubscribe();
    }
  }
}
